import React, { useState, useRef } from 'react'
import useOutsideClick from '@/hooks/useOutsideClick'
import * as S from './styles'

interface Option {
  id: string
  name: string
}

interface CustomSelectProps {
  id: string
  value: string
  onChange: (value: string) => void
  options: Option[]
  placeholder?: string
  required?: boolean
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  id,
  value,
  onChange,
  options,
  placeholder = 'Selecione uma opção',
  required = false
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectRef = useRef<HTMLDivElement>(null)

  const selectedOption = options?.find(option => option?.id === value)

  const handleSelect = (optionId: string) => {
    setIsOpen(false)
    onChange(optionId)
  }

  const toggleDropdown = () => {
    setIsOpen(prev => !prev)
  }

  useOutsideClick(selectRef, () => setIsOpen(false))

  return (
    <S.CustomSelectContainer ref={selectRef}>
      <S.CustomSelectButton
        id={id}
        onClick={toggleDropdown}
        type="button"
        required={required}
      >
        <S.CustomSelectText hasValue={!!selectedOption}>
          {selectedOption ? selectedOption.name : placeholder}
        </S.CustomSelectText>
        <S.CustomSelectArrow isOpen={isOpen}>
          <span className="material-icons">keyboard_arrow_down</span>
        </S.CustomSelectArrow>
      </S.CustomSelectButton>

      <S.CustomSelectDropdown isOpen={isOpen}>
        <S.CustomSelectList>
          {options?.map((option: Option) => (
            <S.CustomSelectOption
              key={option.id}
              onClick={() => handleSelect(option.id)}
              isSelected={value === option?.id}
            >
              {option?.name}
            </S.CustomSelectOption>
          ))}
        </S.CustomSelectList>
      </S.CustomSelectDropdown>
    </S.CustomSelectContainer>
  )
}

export default CustomSelect
